export const detail =  {
    'TR':[
        [
            'Yapımcı', ['Sergin Akyaz']
        ],
        [
            'Senaryo', ['Sergin Akyaz']
        ],
        [
            'YÖNETMEN', [
                'Hilal Saral'
            ]
        ],
        [
            'Oyuncular', [
                'Deniz Akkaya',
                'Cansu Dere',
                'Mehmet Akif Alakurt',
                'Simge Selçuk',
                'Billur Kalkavan',
                'Sevinç Gürsen Akyıldız',
                'Tekin Temel',
                'Tolga Tibet',
                'Öner Erkan'
            ]
        ]
    ],
    'Eng': [
        [
            'Country', ['Turkey']
        ],
        [
            'Language', ['Turkish']
        ],
        [
            'Executive Producer', ['Sergin Akyaz']
        ],
        [
            'Created by', ['Sergin Akyaz']
        ],
        [
            'Writer',  ['Sergin Akyaz']
        ],
        [
            'Director', [
                'Hilal Saral'
            ]
        ],
        [
            'Cast', [
                'Deniz Akkaya',
                'Cansu Dere',
                'Mehmet Akif Alakurt',
                'Simge Selçuk',
                'Billur Kalkavan',
                'Sevinç Gürsen Akyıldız',
                'Tekin Temel',
                'Tolga Tibet',
                'Öner Erkan'
            ]
        ]
    ]
};